app.controller('helpController', function (
    $scope,
    $auth,
    objectService
) {
    $scope.token = $auth.getToken()
    $scope.manager = objectService.manager
});
